import axios from "axios";

export default {
    saveAppSettings: async (companyId, appId, payload) => {
        const { data } = await axios.post(`/a/${companyId}/features/${appId}/save_settings`, payload)

        return data
    },
    execAppAction: async (companyId, featureId, action, payload) => {
        const { data } = await axios.post(`a/${companyId}/features/${featureId}/${action}`, payload);

        return data;
    }
}
